export interface AnalyticsConfig {
  entryOnly: boolean;
  requireUtm: boolean;
}

export interface SiteConfig {
  analytics: AnalyticsConfig;
}

export const defaultSiteConfig: SiteConfig = {
  analytics: {
    entryOnly: true,
    requireUtm: false,
  },
};
